// extracted by mini-css-extract-plugin
export default {"header":"ToastContent_header__12KFn","title":"ToastContent_title__NJdVs"};